import { render } from "./GridForm.vue?vue&type=template&id=663c8dfa&scoped=true"
import script from "./GridForm.vue?vue&type=script&lang=js"
export * from "./GridForm.vue?vue&type=script&lang=js"

import "./GridForm.vue?vue&type=style&index=0&id=663c8dfa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-663c8dfa"]])

export default __exports__